module.exports = __webpack_public_path__ + "static/media/xls.756174f3.png";